var firmwareList = (function () {
  const init = function () {
    $.fn.dataTableExt.oSort["version-desc"] = function (x, y) {
      const x_version = $(x).text().split('.');
      const y_version = $(y).text().split('.');
      if (parseInt(x_version[0]) > parseInt(y_version[0])) {
        return -1;
      }
      if (parseInt(x_version[1]) > parseInt(y_version[1])) {
        return -1;
      }
      if (parseInt(x_version[2]) > parseInt(y_version[2])) {
        return -1;
      }
      return 1;
    };
    $.fn.dataTableExt.oSort["version-asc"] = function (x, y) {
      const x_version = $(x).text().split('.');
      const y_version = $(y).text().split('.');
      if (parseInt(x_version[0]) > parseInt(y_version[0])) {
        return 1;
      }
      if (parseInt(x_version[1]) > parseInt(y_version[1])) {
        return 1;
      }
      if (parseInt(x_version[2]) > parseInt(y_version[2])) {
        return 1;
      }
      return -1;
    };
    $("#firmwares-datatable").DataTable({
      autoWidth: false,
      responsive: true,
      columnDefs: [
        { type: "version", className: "version-column", targets: 0 },
        { className: "description-column", targets: 1 },
        { className: "dispensers-count-column", targets: 2 },
        { className: "hardwares-count-column", targets: 3 },
        { className: "bootloaders-count-column", targets: 4 },
        { className: "filesize-column", targets: 5 },
        { className: "firmware-actions-column desktop", targets: 6 },
        { orderable: false, targets: 6 },
      ],
      order: [[ 0, "desc" ]],
      language: {
        url: "https://cdn.datatables.net/plug-ins/1.10.19/i18n/Ukrainian.json",
        //TODO: make it depends on current culture not on sdn call
      },
    });

    $("#firmwares-datatable").on("click", ".mdi-delete", function () {
      const id = $(this).data("firmware-id");
      const version = $(this).data("firmware-version");
      $("#firmware-version-to-delete").text(version);
      $("#delete-firmware-button").attr("data-firmware-id", id);
    });

    $("#delete-firmware-button").on("click", function () {
      const firmwareIdToDelete = $(this).data("firmware-id");
      sendDeleteRequest(firmwareIdToDelete);
    });

    $(".download-firmware-button").on("click", function () {
      const firmwareIdToDelete = $(this).data("firmware-id");
      downloadFirmwareFile(firmwareIdToDelete);
    });

    function downloadFirmwareFile(id) {
      $.ajax({
        url: `/Firmwares/DownloadFirmwareFile`,
        method: "GET",
        contentType: "application/json",
        data: {
          firmwareId: id,
        },
        xhrFields: {
          responseType: "blob", // to avoid binary data being mangled on charset conversion
        },
      }).done(function (data, textStatus, jqXHR) {
        var filename = "";
        var disposition = jqXHR.getResponseHeader("Content-Disposition");
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1])
            filename = matches[1].replace(/['"]/g, "");
        }

        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
          window.navigator.msSaveBlob(data, filename);
        } else {
          var URL = window.URL || window.webkitURL;
          var downloadUrl = URL.createObjectURL(data);

          if (filename) {
            // use HTML5 a[download] attribute to specify filename
            var a = document.createElement("a");
            // safari doesn't support this yet
            if (typeof a.download === "undefined") {
              window.location.href = downloadUrl;
            } else {
              a.href = downloadUrl;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location.href = downloadUrl;
          }

          setTimeout(function () {
            URL.revokeObjectURL(downloadUrl);
          }, 100); // cleanup
        }
      });
    }

    function sendDeleteRequest(id) {
      $.ajax({
        url: `/Firmwares/Delete/${id}`,
        method: "DELETE",
        contentType: "application/json",
      }).done(function (data) {
        $("#delete-modal").modal("hide");
        $.showNotification(data.header, data.message, data.succeed);
      });
    }
  };

  return {
    init: init,
  };
})();
